'use client';

import { auth } from '@fe-common/firebase/auth/auth';
import { getDocsArray } from '@fe-common/firebase/get-docs-array';
import { DomExperience } from '@pop-common/objects/dom-experience/dom-experience/dom-experience';
import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';
import { useAsync } from 'react-use';
import LoadingSpinner from './components/LoadingSpinner';
import { WelcomeDialog } from './components/WelcomeDialog';

export default function Home() {
  const [showWelcomeDialog, setShowWelcomeDialog] = useState<boolean | null>(null);
  const router = useRouter();
  const { loading } = useAsync(async () => {
    try {
      if (!auth.currentUser) {
        router.push('/login');
        return;
      }
      const experiences = await getDocsArray<DomExperience>({
        Deserializer: DomExperience,
        limit: 1,
      });

      if (experiences.length < 1) {
        setShowWelcomeDialog(true);
      } else {
        setShowWelcomeDialog(false);
      }
    } catch (error) {
      console.error('Error fetching DomExperiences:', error);
      throw error;
    } finally {
    }
  }, []);

  useEffect(() => {
    if (showWelcomeDialog === false) router.replace('/dashboards');
  }, [showWelcomeDialog, router]);

  if (loading) {
    return (
      <div className="w-full">
        <LoadingSpinner message="Loading your customerized.ai..." />
      </div>
    );
  }

  return (
    <div className="p-4">
      <WelcomeDialog visible={showWelcomeDialog ?? false} onHide={() => setShowWelcomeDialog(false)} />
    </div>
  );
}
